import React from 'react'
import '../../Work-css/Bookings.css';

export default function Displays({setTenancybooking, setHostelbooking, setBooking, setExpdate, setSPA}) {

    const hstb = () =>{
      setHostelbooking(true)
      setBooking(false)
      setTenancybooking(false)
      setExpdate(false)
    }

    const tncb = () =>{
    
      setHostelbooking(false)
      setBooking(false)
      setTenancybooking(true)
      setExpdate(false)
    }

    const exp_date = () =>{
      setExpdate(true)
      setHostelbooking(false)
      setBooking(false)
      setTenancybooking(false)
    }

    const short_PA = () =>{
      setBooking(false)
      setSPA(true)
    }
  return (
    <div className='displays_full'>
        <div className='displays_btn'>

            <div>
                <p className='booking_alert'>Booking is Absolutley Free!!</p>
                <div className='display_btn_buttons' onClick={hstb}>Hostel Booking</div>
                <div className='display_btn_buttons' onClick={tncb}>Tenancy Booking</div>
                <div className='display_btn_buttons' onClick={short_PA} >Short Period Accomodation</div>
              
            </div>

        </div>
    </div>
  )
}
